import React, { Component } from "react";
import styles from "./index.less";
import { CanvasContext } from "../../Context";
import { isTextComponent, isImageComponent } from "../Left";
import Text from "../Text";
import Image from "../Image";
import Lines from "../EditLine/Lines";

export default class Cmp extends Component {
  static contextType = CanvasContext;

  setSelected = (e) => {
    if (e.ctrlKey) {
      this.context.addAndUpdateAssembly(this.props.index);
    } else {
      this.context.setSelectedCmpIndex(this.props.index);
    }
  };

  render() {
    const { cmp, index } = this.props;
    const { style } = cmp;

    const { width, height } = style;
    const transform = `rotate(${style.transform}deg)`;

    const zIndex = index;

    const belongingToAssembly = this.context.belongingToAssembly(index);

    return (
      <div
        id={cmp.key}
        className={styles.main}
        style={{
          ...style,
          transform,
          zIndex,
        }}
        onClick={this.setSelected}
      >
        {belongingToAssembly && <Lines style={{ width, height, transform }} />}

        <div
          className={styles.cmp}
          style={{
            width: style.width,
            height: style.height,
          }}
        >
          {cmp.type === isTextComponent && <Text {...cmp} />}
          {cmp.type === isImageComponent && <Image {...cmp} />}
        </div>
      </div>
    );
  }
}
